<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': false }"
>
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Recent Accessed Entities</h3>
    </div>
    <div style="display: flex">
      <mat-form-field class="mt-3 mr-3 mat-form-field-fluid">
        <mat-label>Search</mat-label>
        <input type="text" matInput #searchEle [matAutocomplete]="auto1" />
        <mat-hint>By Patient, Doctor & Contact</mat-hint>
        <button
          *ngIf="currentSearch"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="selectedSearch('')"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete
          [panelWidth]="auto1"
          #auto1="matAutocomplete"
          [displayWith]="stringUtils.displayName(this)"
          (optionSelected)="selectedSearch($event.option.value)"
        >
          <mat-option *ngFor="let option of searchResultOptions" [value]="option">
            <div
              [innerHTML]="stringUtils.autocompleteEntityFormatter(option) | safe : 'html'"
            ></div>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <ng-template ngxPermissionsOnly="accessToOtherRecentAccess">
        <mat-form-field class="mt-3 mat-form-field-fluid">
          <mat-label>User</mat-label>
          <input type="text" matInput #userEle [matAutocomplete]="auto" />
          <button
            *ngIf="currentUser"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="selectedUser('')"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-autocomplete
            [panelWidth]="auto"
            #auto="matAutocomplete"
            [displayWith]="this | getUserName"
            (optionSelected)="selectedUser($event.option.value)"
          >
            <mat-option *ngFor="let option of userOptions" [value]="option">
              <span> {{ option | getUserName }} </span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </ng-template>
    </div>
  </div>
  <div class="form">
    <div style="flex: 1 1 auto; min-height: 1px; padding: 1.25rem; padding-top: 0px !important">
      <div class="form-group row">
        <div class="col-lg-12">
          <div style= "max-height: 500px;overflow-y: scroll;">
          <table class="table table-sm table-hover cursor-pointer">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Type</th>
                <th scope="col">Access From</th>
                <th scope="col">Access On</th>
              </tr>
            </thead>
            <tbody *ngFor="let x of list">
              <tr (click)="openRelatedTo(x.entity_type, x.entity_id)">
                <td>
                  <div
                    *ngIf="
                      allContacts.length != 0 &&
                      allContacts[x.entity_id] &&
                      x.entity_type === 'CONTACT'
                    "
                  >
                    {{ allContacts[x.entity_id] | getEntityName }}
                  </div>
                  <div
                    *ngIf="
                      allEntities.length != 0 &&
                      allEntities[x.entity_id] &&
                      x.entity_type !== 'CONTACT'
                    "
                  >
                    {{ allEntities[x.entity_id] | getEntityName }}
                  </div>
                </td>
                <td>{{ x.entity_type }}</td>
                <td>{{ x.access_from }}</td>
                <td style="width: 150px">{{ x.created + 'Z' | date : 'yyyy-MM-dd h:mm a ' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div class="mat-table-bottom">
            <mat-spinner [diameter]="20" *ngIf="loading"></mat-spinner>
            <mat-paginator
              [pageSize]="size"
              [pageSizeOptions]="[10, 25, 50, 200]"
              [length]="totalNumber"
              (page)="loadPage($event)"
              [showFirstLastButtons]="true"
            ></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
